import { Collapsible, Stack, TableColumn } from 'canoe';
import React from 'react';

import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';

import { AnalyticsTable } from '../AnalyticsTable';

interface Props {
  queryId: QueryId;
  label: string;
  queryParams: QueryParamUrlObject;
  columns: TableColumn[];
}

export const CollapsableTable = ({ queryId, queryParams, label, columns }: Props) => {
  return (
    <Stack>
      <Collapsible bordered label={label} removeOnCollapse={false}>
        <AnalyticsTable id={queryId} columns={columns} query={queryParams} pageCount={8} />
      </Collapsible>
    </Stack>
  );
};
